export enum PagesEnum {
    ANALYTICS = "Analytics",
    TICKET_MANAGEMENT = "Ticket Management",
    SUBSCRIPTION_PLAN = "Subscription Plan",
    EMPLOYEES = "Employees",
    CREATE_EMPLOYEES = "Employees / Create new Employee",
    EDIT_PROFILE = "Edit my Profile"
}